import { render, staticRenderFns } from "./ToolIcons.vue?vue&type=template&id=700cd9ec&"
var script = {}
import style0 from "./ToolIcons.vue?vue&type=style&index=0&id=700cd9ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports